export const homeModalSessionInfo = {
  homeModalSessionInfotitle: "Welkom terug!",
  homeModalSessionInfotitleCurrentBalance: "Huidige saldo",
  homeModalSessionInfoLastConnection: "Laaste toegang",
  homeModalSessionInfoLastConnectionAtTime: "om",
  homeModalSessionInfoLowBalanceWarning: "Jou saldo raak min. Wil jy meer geld deponeer?",
  homeModalSessionInfoGoToDeposit: "Deponeer",
  homeModalSessionInfoContinue: "Gaan voort",
  homeModalSessionInfoDeposit: "Wil jy meer geld deponeer?",
  homeModalSessionInfoAtTime: "om",
};
